import React, { useContext, useState } from 'react';
import { Navigate } from 'react-router-dom';
import {
  Box,
  Container,
  makeStyles,
  Typography,
  Grid,
  Paper,
  Divider
} from '@material-ui/core';
import Page from 'src/components/Page';

import Input from '../../../../shared/component/FormElements/Input';
import Button from '../../../../shared/component/FormElements/Button';
import Destaque from '../../../../shared/component/FormElements/Destaque';
import ErrorMessage from '../../../../shared/component/UIElements/ErrorMessage';
import LoadingSpinner from '../../../../shared/component/UIElements/LoadingSpinner';
import {
  VALIDATOR_REQUIRE,
} from '../../../../utils/validators';
import { useForm } from '../../../../hooks/form-hook';
import { useHttpClient } from '../../../../hooks/http-hook';
import { AuthContext } from '../../../../shared/context/auth-context';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  titulo: {
    color: '#3A3A3A',
    fontWeight: 700,
    fontSize: '24px',
    marginBottom: '15px'
  },
  button: {
    marginTop: '15px',
    display: 'block',
    color: 'white',
    borderRadius: '23px',
    WebkitBorderRadius: '23px',
    MozBorderRadius: '23px'
  }
}));

const Nova = () => {
  const classes = useStyles();
  const auth = useContext(AuthContext);
  const [navegar, setNavegar] = useState(false);
  const {
    isLoading,
    error,
    sendRequest,
    clearError
  } = useHttpClient();
  const [formState, inputHandler] = useForm({
    imagem: {
      value: '',
      isValid: true
    },
    nome: {
      value: '',
      isValid: false
    },
  }, false);
  const novoSubmitHandler = async (event) => {
    event.preventDefault();
    try {
      const formulario = new FormData();
      formulario.append('nome', formState.inputs.nome.value);
      formulario.append('imagem', formState.inputs.imagem.value);
      const response = await sendRequest(
        `${process.env.REACT_APP_BACKEND_URL}/mapas`,
        'POST',
        formulario,
        {
          'x-access-token': auth.token
        }
      );
      console.log(response);
      if (response.sucesso) {
        setNavegar('app/mapas/');
      }
    } catch (err) {
      console.log(err);
    }
  };
  if (navegar) {
    return <Navigate to={`/${navegar}`} />;
  }
  return (
    <Page
      className={classes.root}
      title="Adicionar Nova Sala"
    >
      <Container maxWidth="md">
        <Paper p={3} style={{ padding: '15px' }}>
          <Box mt={3}>
            <form onSubmit={novoSubmitHandler}>
              <Box my={2}>
                <Typography
                  color="textPrimary"
                  align="left"
                  variant="h2"
                  className={classes.titulo}
                >
                  Cadastrar nova Sala
                </Typography>
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <Destaque
                      id="imagem"
                      name="imagem"
                      onInput={inputHandler}
                      validators={[]}
                      initialValid
                      initialValue=""
                      errorText="Insira a imagem da sala."
                      label="Imagem da Sala"
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Input
                      id="nome"
                      element="input"
                      type="text"
                      label="Nome da Sala"
                      fullWidth
                      validators={[VALIDATOR_REQUIRE()]}
                      errorText="Insira um nome."
                      onInput={inputHandler}
                      variant="outlined"
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </Grid>
                </Grid>
                <Divider variant="middle" style={{ margin: '30px 0px' }} />
                <Button
                  color="secondary"
                  disabled={!formState.isValid}
                  fullWidth
                  size="large"
                  type="submit"
                  variant="contained"
                  marginBottom={5}
                  classes={classes.button}
                >
                  Salvar Sala
                </Button>
              </Box>
              {isLoading && <LoadingSpinner asOverlay />}
              <ErrorMessage error={error} onClear={clearError} />
            </form>
          </Box>
        </Paper>
      </Container>
    </Page>
  );
};
export default Nova;
